import apiUrl from '../../../../utils/settings';

export const reverseGeocodeUrl = () => {
  return apiUrl + '/address/reverse-geocode';
};

export const addressDetailUrl = () => {
  return apiUrl + '/address/addresses';
};


export const saveAddressUrl = () => {
  return apiUrl + '/address';
};
export const editAddressUrl = () => {
  return apiUrl + '/address';
};

export const deleteAddressUrl = () => {
  return apiUrl + '/address';
};

export const convertAddressToCoordinatesUrl = () => {
  return apiUrl + '/address/geocode-address';
};
